import { createUserCheckout, getUserOrder } from 'api/purchase'
import { orderState } from '../constants'
import { sleep } from '@paladise/utils/sleep'
import { clientFetch } from 'lib/fetch/client'

export const checkUserOrderState = async (orderId: string) => {
  // wait for server receive stripe webhook
  let count = 0
  while (count < 10) {
    const order = await getUserOrder(clientFetch, orderId)
    if (order === orderState.success) return true

    count++
    await sleep(1000)
  }
  return false
}

export const subscriptionPlan = async (productId: string) => {
  try {
    const checkout = await createUserCheckout(clientFetch, productId)

    if (typeof checkout === 'string') return false
    if (!checkout?.order_id) return true

    const success = await checkUserOrderState(checkout.order_id)

    return success
  } catch (error) {
    return false
  }
}
